import * as React from 'react';
import GridContainer from "../../GenericComponents/Grids/GridContainer";
import {toast} from "react-toastify";
import * as actionTypes from "../../../store/action";
import {connect} from "react-redux";
import {createBreadCrumbBasedOnPage} from "../../../Utils/HelperFunctions";
import {Button, ButtonProps, Container, Dimmer, Header, Icon, Loader, Segment} from "semantic-ui-react";
import history from "../../../history";
import {Redirect} from "react-router";
import UpgradeApi from "../../../services/upgrade-service";
import TracWebForm from "../../GenericComponents/TracWebForm";
import UpgradeFormSection from "./UpgradeFormSection";

interface GenerationInterconnectionUpgradeFormProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
    location: any;
    setLoggedIn: (loggedIn:boolean) => void;
    loggedIn: boolean;
    backToMainUpgradeForm: (savedTopLevelForm:boolean) => void;
    topLevelUpgradeFormObject: InitialUpgradeCreateResponse;
    topLevelFormMetaData ?: any;
}

interface GenerationInterconnectionUpgradeFormState {
    pageLoading: boolean
    userAuthorized: boolean
    giFormObject: GenerationInterconnectionForm;
    formMetaData: any
    submitClicked: boolean
    numberOfSectionsChecked: number
    canSubmit: boolean
    requiredMissing: boolean | null
    requiredArray: Map<string, boolean>
}

class GenerationInterconnectionUpgradeForm extends React.Component<GenerationInterconnectionUpgradeFormProps,GenerationInterconnectionUpgradeFormState> {
    private upgradeClient: UpgradeApi;

    constructor(props: GenerationInterconnectionUpgradeFormProps) {
        super(props);
        this.state = {
            pageLoading: true,
            userAuthorized: false,
            submitClicked: false,
            numberOfSectionsChecked: 0,
            canSubmit: false,
            requiredMissing: null,
            requiredArray: new Map(),
            giFormObject: {
                generationInterconnectionDetailsRequest: {
                    facilityOwnerCode: '',
                    networkUpgradeType: '',
                    upgradeCategoryType: '',
                    fundingType: '',
                    scertViewType: '',
                    giDependencyOnUpgrade: false,
                    bundleCount: 0,
                    capacityMwRate: 0,
                    generatingFacilityType: '',
                    giUpgradeType: '',
                    highVoltageKvRate: 0,
                    lowVoltageKvRate: 0,
                    ratingMvaRate: 0,
                    substationOrTransmissionLineType: '',
                    transmissionLineLength: 0,
                    turbineModelName: '',
                    upgradeFinalCost: 0,
                    modelArea1FacilityId: 0,
                    modelArea2FacilityId: 0,
                    studyGeneratorNumber: '',
                    giInServiceDate: null,
                    towerConfigurationDescription: '',
                    generatorDescription: '',
                    rightOfWayDescription: '',
                    upgradeJustificationComment: '',
                    conductorDescription: ''
                },
                upgradeBusRequest: {
                    fromBusNumber: '',
                    fromBusTempInd: false,
                    toBusNumber: '',
                    toBus1TempInd: false,
                    tertiaryBusNumber: '',
                    toBus2TempInd: false,
                    circuitCode: '',
                    designKvRate: 0,
                    highVoltageKvRate: 0,
                    lowVoltageKvRate: 0,
                    newMilesCount: 0,
                    operatingKvRate: 0,
                    reconductorMiles: 0,
                    summerEmergencyRatingMvaRate: 0,
                    summerNormalRatingMvaRate: 0,
                    tertiaryVoltageKvRate: 0,
                    voltageConversionMiles: 0,
                    winterEmergencyRatingMvaRate: 0,
                    winterNormalRatingMvaRate: 0,
                    totalRatingDescription: ''
                },
                upgradeCostInfoRequest: {
                    upgradeCostEstimateDate: null,
                    upgradeEstimatedCostAmount: 0,
                    upgradeEstimatedCostSourceDescription: '',
                    upgradeFinalCostAmount: 0,
                    sourceOfFinalCost: '',
                    finalCostReceivedDate: null,
                    requestForFinalCostSentDate: null,
                    originalEstimatedCost: 0,
                    sppEstimatedCost: 0
                }
            },
            formMetaData: null
        };

        this.upgradeClient = new UpgradeApi();
    }

    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));

        this.getGiUpgradeFormDetails();
        let { requiredArray } = this.state;
        requiredArray.set('giForm', false);
        requiredArray.set('upgradeBusForm', false);
        requiredArray.set('upgradeCostInfoForm', false);
        this.setState({requiredArray});
    }

    componentDidUpdate(prevProps: Readonly<GenerationInterconnectionUpgradeFormProps>, prevState: Readonly<GenerationInterconnectionUpgradeFormState>) {
        /*if(this.state.canSubmit && this.state.submitClicked) {
            toast.success('Successfully created upgrade');
        }*/
        if(this.state.canSubmit && this.state.submitClicked) {
            let readyToSubmit = true;
            this.state.requiredArray.forEach(function(value, key) {
                if(value === false) {
                    readyToSubmit = false;
                }
            });
            if(readyToSubmit) {
                let upgradeCreateRequest: CreateUpgradeRequest = {
                    initialUpgradeCreateResponse: this.props.location.state.topLevelUpgradeFormObject,
                    generationInterconnectionRequest: this.state.giFormObject,
                    reliabilityExpansionRequest: null,
                    transmissionServiceRequest: null
                }

                this.upgradeClient.submitUpgradeRequest(upgradeCreateRequest)
                    .then((response:any) => {
                        if(response === 'Success') {
                            toast.success('Successfully created GI upgrade');
                            const currentPath = this.props.location.pathname;
                            history.push({
                                pathname: '/upgrades',
                                state: {from: currentPath}
                            });
                        }
                        else {
                            toast.warn('Issue creating upgrade.  Please contact IT.');
                        }
                    })
                this.setState({canSubmit: false});
            }
            else {
                this.setState({submitClicked: false});
            }
        }
    }

    getGiUpgradeFormDetails = () => {
        this.upgradeClient.getGiUpgradeCreateForm()
            .then((response: any) => {
                this.setState({
                    giFormObject: response.data[0],
                    formMetaData: response.columnMetaDataList,
                    userAuthorized: true,
                    pageLoading: false
                });
            })
            .catch((error: any) => {
                if (error.response.status === 403) {
                    this.setState({userAuthorized: false, pageLoading: false});
                }
                if (!error.response.data.badToken) {
                    toast.error(`Error retrieving data from the server - ${error.response.data.message}`)
                } else {
                    this.props.setLoggedIn(false);
                }
            });
    };

    /*updateForm = () => {
        const { giFormObject, formMetaData } = this.state;
        toast.success("successfully save form");
        const currentPath = this.props.location.pathname;
        history.push({
            pathname: this.props.location.state !== undefined ? this.props.location.state.from : '/upgrades',
            state: {from: currentPath}
        });
    };*/

    resetWebForm = () => {
        let { giFormObject } = this.state;
        giFormObject = {
            generationInterconnectionDetailsRequest: {
                facilityOwnerCode: '',
                networkUpgradeType: '',
                upgradeCategoryType: '',
                fundingType: '',
                scertViewType: '',
                giDependencyOnUpgrade: false,
                bundleCount: 0,
                capacityMwRate: 0,
                generatingFacilityType: '',
                giUpgradeType: '',
                highVoltageKvRate: 0,
                lowVoltageKvRate: 0,
                ratingMvaRate: 0,
                substationOrTransmissionLineType: '',
                transmissionLineLength: 0,
                turbineModelName: '',
                upgradeFinalCost: 0,
                modelArea1FacilityId: 0,
                modelArea2FacilityId: 0,
                studyGeneratorNumber: '',
                giInServiceDate: null,
                towerConfigurationDescription: '',
                generatorDescription: '',
                rightOfWayDescription: '',
                upgradeJustificationComment: '',
                conductorDescription: ''
            },
            upgradeBusRequest: {
                fromBusNumber: '',
                fromBusTempInd: false,
                toBusNumber: '',
                toBus1TempInd: false,
                tertiaryBusNumber: '',
                toBus2TempInd: false,
                circuitCode: '',
                designKvRate: 0,
                highVoltageKvRate: 0,
                lowVoltageKvRate: 0,
                newMilesCount: 0,
                operatingKvRate: 0,
                reconductorMiles: 0,
                summerEmergencyRatingMvaRate: 0,
                summerNormalRatingMvaRate: 0,
                tertiaryVoltageKvRate: 0,
                voltageConversionMiles: 0,
                winterEmergencyRatingMvaRate: 0,
                winterNormalRatingMvaRate: 0,
                totalRatingDescription: ''
            },
            upgradeCostInfoRequest: {
                upgradeCostEstimateDate: null,
                upgradeEstimatedCostAmount: 0,
                upgradeEstimatedCostSourceDescription: '',
                upgradeFinalCostAmount: 0,
                sourceOfFinalCost: '',
                finalCostReceivedDate: null,
                requestForFinalCostSentDate: null,
                originalEstimatedCost: 0,
                sppEstimatedCost: 0
            }
        };

        this.setState({giFormObject});
        toast.info('Cleared All Generation Interconnection Form Fields');
    };


    backToMainForm = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        const currentPath = this.props.location.pathname;
        history.push({
            //pathname: this.props.location.state !== undefined ? this.props.location.state.from : '/upgrades/createUpgrade/',
            pathname: '/upgrades/createUpgrade',
            state: {from: currentPath, topLevelUpgradeFormObject: this.props.location.state.topLevelUpgradeFormObject, topLevelFormMetaData: this.props.location.state.topLevelFormMetaData}
        });
        //this.props.backToMainUpgradeForm(false);
    };

    saveWebForm = () => {
        /*let upgradeCreateRequest: CreateUpgradeRequest = {
            initialUpgradeCreateResponse: this.props.topLevelUpgradeFormObject,
            generationInterconnectionRequest: this.state.giFormObject,
            reliabilityExpansionRequest: null,
            transmissionServiceRequest: null
        }

        this.upgradeClient.submitUpgradeRequest(upgradeCreateRequest)
            .then((response:any) => {
                toast.success('Successfully created upgrade');
            })*/

        let { requiredArray } = this.state;
        requiredArray.set('giForm', false);
        requiredArray.set('upgradeBusForm', false);
        requiredArray.set('upgradeCostInfoForm', false);
        this.setState({submitClicked:true, requiredMissing: null, requiredArray, canSubmit: true, numberOfSectionsChecked: 0});
    };



    updateAccordionContent = (sectionContent:any, sectionName:string) => {
        let { giFormObject } = this.state;
        switch(sectionName) {
            case 'giForm':
                giFormObject.generationInterconnectionDetailsRequest = sectionContent;
                break;
            case 'upgradeBusForm':
                giFormObject.upgradeBusRequest = sectionContent;
                break;
            case 'upgradeCostInfoForm':
                giFormObject.upgradeCostInfoRequest = sectionContent;
                break;
        }

        this.setState({giFormObject});
    };

    setRequiredFieldsInSectionFilledIn = (missingRequired:boolean, sectionName:string) => {
        let { requiredArray } = this.state;
        if(missingRequired) {
            requiredArray.set(sectionName, false);
        }
        else {
            requiredArray.set(sectionName, true);
        }
        this.setState({requiredArray});
        /*if(missingRequired) {
            this.setState({canSubmit: false, numberOfSectionsChecked: 1});
        }*/
        /*let { numberOfSectionsChecked } = this.state;
        numberOfSectionsChecked++;
        if(!missingRequired) {
            this.setState({numberOfSectionsChecked});
            if(numberOfSectionsChecked === 3) {
                toast.info('Required all filled in');
            }
        }*/
        /*if(missingRequired) {
            this.setState({numberOfSectionsChecked});
        }
        else {
            if(numberOfSectionsChecked === 3) {
                let upgradeCreateRequest: CreateUpgradeRequest = {
                    initialUpgradeCreateResponse: this.props.topLevelUpgradeFormObject,
                    generationInterconnectionRequest: this.state.giFormObject,
                    reliabilityExpansionRequest: null,
                    transmissionServiceRequest: null
                }

                this.upgradeClient.submitUpgradeRequest(upgradeCreateRequest)
                    .then((response:any) => {
                        toast.success('Successfully created upgrade');
                    })

                toast.info('everything filled in');

                //this.setState({submitClicked:false, numberOfSectionsChecked: 0});
            }
            else {
                //let sectionsChecked = this.state.numberOfSectionsChecked;
                numberOfSectionsChecked++;
                this.setState({numberOfSectionsChecked});
            }
        }*/

        /*if(numberOfSectionsChecked === 3) {
            this.setState({submitClicked:false, numberOfSectionsChecked: 0});
        }
        else {
            this.setState((prevState, props) => ({
                numberOfSectionsChecked: prevState.numberOfSectionsChecked + 1
            }));
        }*/
    };

    render() {
        if(this.props.location.state === undefined || this.props.location.state.topLevelUpgradeFormObject === undefined || this.props.location.state.topLevelUpgradeFormObject.upgradeType === '') {
            return (
                <Redirect to={'/upgrades/createUpgrade'} />
            )
        }

        return (
            <Container fluid={true}>
                <Button icon={true} labelPosition='left' onClick={this.backToMainForm}>
                    <Icon name={'arrow left'} />
                    Back to Main Upgrade Form
                </Button>
                <Segment basic={true}>
                    {this.props.loggedIn && this.state.userAuthorized &&
                    <React.Fragment>
                        <Header as='h2' block={true}>
                            Add New Generation Interconnection Upgrade
                        </Header>
                        <UpgradeFormSection
                            location={this.props.location}
                            sectionMetaDataEndpoint={'/getGiUpgradeFormMetaData'}
                            sectionName={'giForm'}
                            segmentHeader={'Generation Interconnect Form'}
                            accordionContent={this.state.giFormObject.generationInterconnectionDetailsRequest}
                            formMetaData={this.state.formMetaData}
                            resetWebForm={this.resetWebForm}
                            updateAccordionContent={this.updateAccordionContent}
                            submissionClicked={this.state.submitClicked}
                            setRequiredFieldsMissingInForm={this.setRequiredFieldsInSectionFilledIn}
                        />
                        <UpgradeFormSection
                            location={this.props.location}
                            sectionMetaDataEndpoint={'/getUpgradeBusMetaData'}
                            sectionName={'upgradeBusForm'}
                            segmentHeader={'Generation Interconnection Upgrade Bus Info'}
                            accordionContent={this.state.giFormObject.upgradeBusRequest}
                            formMetaData={this.state.formMetaData}
                            resetWebForm={this.resetWebForm}
                            updateAccordionContent={this.updateAccordionContent}
                            submissionClicked={this.state.submitClicked}
                            setRequiredFieldsMissingInForm={this.setRequiredFieldsInSectionFilledIn}
                        />
                        <UpgradeFormSection
                            location={this.props.location}
                            sectionMetaDataEndpoint={'/getUpgradeCostInfoMetaData'}
                            sectionName={'upgradeCostInfoForm'}
                            segmentHeader={'Generation Interconnection Upgrade Cost Info'}
                            accordionContent={this.state.giFormObject.upgradeCostInfoRequest}
                            formMetaData={this.state.formMetaData}
                            resetWebForm={this.resetWebForm}
                            updateAccordionContent={this.updateAccordionContent}
                            submissionClicked={this.state.submitClicked}
                            setRequiredFieldsMissingInForm={this.setRequiredFieldsInSectionFilledIn}
                        />
                        <div className={'tracWebFormButtonDiv'}>
                            <Button content={'Submit'} primary={true} onClick={this.saveWebForm}/>
                            <Button content={'Reset'} negative={true} onClick={this.resetWebForm}/>
                        </div>
                    </React.Fragment>
                    }
                    <Dimmer className={'pageLoader'} active={this.state.pageLoading} inverted={true}>
                        <Loader size='large'>Loading</Loader>
                    </Dimmer>
                </Segment>
            </Container>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        loggedIn: state.defaultReducer.loggedIn
    }
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setLoggedIn: (loggedIn: boolean) => dispatch(
            {type: actionTypes.LOGGED_IN, payload: loggedIn}),
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GenerationInterconnectionUpgradeForm);